module.exports = __webpack_public_path__ + "static/media/surgeon-ready-logo.755ad0cf.png";